export const MIMETypePPTX = 'application/msword,application/vnd.ms-excel,'
    + 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,'
    + 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,'
    + 'application/vnd.ms-powerpoint,'
    + 'application/vnd.openxmlformats-officedocument.presentationml.presentation,'
    + 'application/pdf,'
    + 'application/vnd.xmind.workbook';
export const MIMETypeJSON = 'application/json';
export const Exts = 'text/plain,.xlsx,.xls,.doc,.docx,.csv,.txt,.ppt,.pptx,.pdf,.pos,.xmind,.vsd,.vsdx,.mm,.km,.mmap';
export const Others = 'application/vnd.visio,application/vnd.ms-visio.viewer,application/vnd.ms-visio.drawing,application/zip,.zip';
export const POTypes = '.pos,.xmind,.vsd,.vsdx,.mm,.km,.mmap,.zip';

// 本地导入文件需自定义大小品类
const FileType = {
    DOC: 'doc',
    SHEET: 'sheet',
    SLIDE: 'slide',
    PDF: 'pdf',
};

// 文件分类(优先type固定后缀，兼容文件后缀)
export const SuffixFileType = {
    doc: FileType.DOC,
    docx: FileType.DOC,
    document: FileType.DOC,
    msword: FileType.DOC,
    xls: FileType.SHEET,
    xlsx: FileType.SHEET,
    sheet: FileType.SHEET,
    'ms-excel': FileType.SHEET,
    ppt: FileType.SLIDE,
    pptx: FileType.SLIDE,
    presentation: FileType.SLIDE,
    'ms-powerpoint': FileType.SLIDE,
    pdf: FileType.PDF,
};

// 各品类本地导入文件大小限制(单位M)-非指定品类的保留原有逻辑
export const FileMaxSize = {
    [FileType.DOC]: 30,
    [FileType.SHEET]: 30,
    [FileType.SLIDE]: 500,
    [FileType.PDF]: 200,
    POTYPES: 20,
    OTHERS: 100,
};
